import forOwn from 'mout/object/forOwn'

/**
 * Creates activeItems object using data from the activeSet object
 * @param {object} activeSet The object for the currently active set 
 * @returns {object} Active items
 */
export default function findActiveItems(activeSet) {
  let activeItems = {}
  if (activeSet) {
    if (activeSet.content) {
      forOwn(activeSet.content, (val, key, o) => {
        if (val.active) {
          activeItems[key] = true
        }
      })
    }
  }
  return activeItems
}


// WEBPACK FOOTER //
// ./src/helpers/content/manageSets/findActiveItems.js